import { useLocation } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import { Helmet } from 'react-helmet-async';
import classNames from 'classnames';

import { ADSENSE_BLACKLIST_URLS } from '@constants';

import s from './ProductDetailsAds.sss';

interface Props {
  className?: string,
}

export const ProductDetailsAds: React.FC<Props> = ({
  className,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const location = useLocation();

  useEffect(() => {
    const isCanShow = !ADSENSE_BLACKLIST_URLS.some((url) => location.pathname.includes(url));

    const containerElement = containerRef.current;
    const adsenseElement = document.createElement('ins');

    if (isCanShow && containerElement) {
      adsenseElement.classList.add('adsbygoogle');
      adsenseElement.style.display = 'block';
      adsenseElement.setAttribute('data-ad-client', 'ca-pub-4989628462824154');
      adsenseElement.setAttribute('data-ad-slot', '6356885363');
      adsenseElement.setAttribute('data-ad-format', 'auto');
      adsenseElement.setAttribute('data-full-width-responsive', 'true');

      containerElement.appendChild(adsenseElement);

      // @ts-ignore
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    }

    return () => {
      if (containerElement?.contains(adsenseElement)) {
        containerElement.removeChild(adsenseElement);
      }
    };
  }, [location.pathname]);

  return (
    <>
      <Helmet>
        <script
          async={true}
          src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"
        />
      </Helmet>

      <div
        ref={containerRef}
        className={classNames(s.root, className)}
      />
    </>
  );
};
